import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import Label from '../../../components/atoms/display/Label'
import { FlexColumn, FlexRow } from '../../../components/atoms/layout/Flex'
import Button from '../../../components/atoms/inputs/Button'
import DotPagination from '../../../components/atoms/navigation/DotPagination'
import useRouter from '../../../hooks/useRouter'
import Checkbox from '../../../components/atoms/inputs/Checkbox'
import { AttachmentIcon, DeleteIcon } from '../../../components/atoms/display/Icons'
import FileSelectButton from '../../../components/atoms/inputs/FileSelectButton'
import { CompanyActions } from '../../../store/company'
import IconButton from '../../../components/atoms/inputs/IconButton'

export default function RegisterContracteeRepresentative() {
  const [selectedFiles, setSelectedFiles] = useState<File[]>([])
  const [selectedFileError, setSelectedFileError] = useState<string | null>(null)
  const [agreement, setAgreement] = useState(false)
  const router = useRouter()
  const dispatch = useDispatch()

  const handleSelect = useCallback(
    (files: File[]) => {
      setSelectedFileError(null)
      if (selectedFiles.length + files.length > 2) {
        setSelectedFileError('本人確認書類は３件以上アップロードできません')
        return
      }
      setSelectedFiles([...selectedFiles, ...files])
    },
    [selectedFiles]
  )

  const handleDelete = useCallback(
    (file: File) => {
      setSelectedFiles(selectedFiles.filter((f) => f !== file))
    },
    [selectedFiles]
  )

  const handleNext = useCallback(() => {
    if (selectedFiles) {
      dispatch(CompanyActions.uploadRepresentativeCertification({ files: selectedFiles, redirectToCompleted: false }))
    }
    router.registerContracteeBank()
  }, [dispatch, selectedFiles, router])

  return (
    <FlexColumn align="center" height="calc(100vh - 128px)" justify="space-between" mt={4}>
      <FlexColumn align="center">
        <Label text="本人確認書類の提出" variant="title" />
        <FlexColumn width="360px">
          <Label text="運転免許証（表面・裏面）または、押印済みの紙のスキャンをアップロードしてください。" />
          <FileSelectButton accepts={['application/pdf', 'image/jpeg', 'image/png']} multiple onSelect={handleSelect}>
            本人確認書類の選択
          </FileSelectButton>
          <FlexColumn align="flex-start">
            {selectedFiles.map((file) => (
              <FlexRow justify="center" align="center">
                <AttachmentIcon />
                <Label text={file.name} />
                <IconButton label="削除" onClick={() => handleDelete(file)}>
                  <DeleteIcon />
                </IconButton>
              </FlexRow>
            ))}
            {selectedFiles.length === 0 && <Label text="本人確認に必要な書類を選択してください" />}
          </FlexColumn>
          {selectedFileError && <Label text={selectedFileError} color="error" />}
          <Checkbox label="取引先とmonectで電子契約することに同意する" checked={agreement} onChange={setAgreement} />
          <FlexColumn space={0}>
            <Label
              text="※ 本人確認書類をアップロードしたうえで、内容に誤りがないことを必ずご確認の上、承認してください。"
              variant="caption"
            />
            <Label text="承認後は修正できません。" variant="caption" />
          </FlexColumn>
        </FlexColumn>
      </FlexColumn>
      <FlexColumn align="center">
        <Button variant="text" size="lg" onClick={router.registerContracteeBank}>
          この項目をスキップ
        </Button>
        <Button size="lg" disabled={selectedFiles.length === 0 || !agreement} onClick={handleNext}>
          次へ
        </Button>
        <FlexRow justify="center">
          <DotPagination count={13} current={10} />
        </FlexRow>
      </FlexColumn>
    </FlexColumn>
  )
}
